<template>
    <div class="modal fade" id="voucherModal" ref="voucherModal" tabindex="-1" aria-labelledby="voucherModal"
        aria-hidden="true">
        <div
            class="modal-dialog modal-dialog-centered w-full right-0 left-0 !mx-auto mobile:!px-3 tablet:!w-[400px] laptop:!px-0 !absolute !top-0 !m-0 h-full">
            <div class="modal-content !p-2.5 !pb-4">
                <div class="relative rounded-[10px] overflow-hidden h-[80px] bg-customBlue-100">
                    <button @click="closeModal" type="button"
                        class="absolute top-3 right-[10px] w-[30px] h-[30px] z-50 focus:!outline-none focus:!shadow-none"
                        data-bs-dismiss="modal" aria-label="Close">
                        <img src="../../../assets/images/modal-cross-icon.svg" alt="Cross Icon"
                            class="w-[30px] h-[30px] object-contain">
                    </button>
                    <h3
                        class="absolute top-0 left-0 w-full h-full flex items-center justify-start m-0 font-poppins font-semibold text-center text-[20px] px-[15px] text-white">
                        Promo Code
                    </h3>
                </div>
                <div class="modal-body !p-0 mobile:mt-[10px] laptop:mx-[30px] !mt-[30px] mb-[10px]">
                    <div>
                    <inputComponent ref="voucherCodeRef" v-model="voucher_code" name="voucherCode" required
                        placeholder="Enter Promo Code" length="12" :regex="$constants.PROMOCODE_REGEX"
                        error-message="Invalid Introductory Offer (Letters and numbers only)."
                        customClass="!text-[16px] font-poppins font-regular outline-none py-2 px-3 w-full !rounded-[5px] border border-[#cccccc] placeholder:text-[#666] text-[#333]" />
                    <span v-if="!$helper.isEmpty(errorMsg)" class="text-xs mt-1 mb-0 text-[#FE5000] font-roboto leading-snug inline-block"  >{{ errorMsg }}</span>
                    </div>
                    <button @click="applyVoucher" :disabled="$helper.isEmpty(voucher_code)"
                        class="group flex items-center gap-[10px] mt-[30px] px-[30px] py-[8px] text-[16px] laptop:text-[18px] font-poppins font-medium rounded-full uppercase mx-auto transition duration-300
         CustomYellowBtn
         disabled:!bg-[#efefef] disabled:cursor-not-allowed disabled:!border-[#efefef] disabled:!text-[#999]
         disabled:hover:!bg-gradient-to-r disabled:hover:from-[#efefef] disabled:hover:to-[#efefef] disabled:hover:cursor-not-allowed disabled:hover:!border-[#efefef] disabled:hover:!text-[#999]">
                        <span>Continue</span>
                        <div class="group-disabled:filter group-disabled:invert group-disabled:brightness-[0.5]">
                            <img src="../../../assets/images/arrow-white-icon.svg" alt="">
                        </div>
                    </button>
                    <!-- <button @click="applyVoucher" :disabled="!voucher_code || voucher_code.length === 0"
                        class="mt-[20px] px-[30px] py-[8px] text-[16px] font-poppins rounded-[10px] w-full transition duration-300
         border-[1px] border-customBlue-100
         mobile:text-white laptop:text-customBlue-100
         !text-[#fff] !bg-customBlue-100
         laptop:bg-white laptop:hover:bg-gradient-to-r laptop:from-[#2459A8] laptop:to-[#117EC2]
         laptop:hover:text-[#fff]
         disabled:!bg-[#E3E3E3] disabled:cursor-not-allowed disabled:!border-[#E3E3E3]
         disabled:hover:!bg-gradient-to-r disabled:hover:from-[#E3E3E3] disabled:hover:to-[#E3E3E3] disabled:hover:cursor-not-allowed disabled:hover:!border-[#E3E3E3]">
                        Apply
                    </button> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Modal } from "bootstrap";
import inputComponent from "../../partialComponent/inputComponent.vue";

export default {
    components: { inputComponent },
    data() {
        return {
            voucher_code: '',
            errorMsg: ''
        }
    },
    watch:{
        voucher_code: function (data) {
            this.errorMsg = ''
        },
    },
    methods: {
        openModal() {
            const { Modal } = require('bootstrap');
            const modalEl = this.$refs.voucherModal;

            this.modal = Modal.getInstance(modalEl);
            if (!this.modal) {
                this.modal = new Modal(modalEl, {
                    backdrop: 'static',
                    keyboard: false
                });
            }
            // Add event listeners for show/hide
            modalEl.addEventListener('show.bs.modal', () => {

                // Reset field state FIRST before clearing values
                if (this.$refs.voucherCodeRef && typeof this.$refs.voucherCodeRef.resetField === "function") {
                    this.$refs.voucherCodeRef.resetField();
                }
                // Then clear the values
                this.voucher_code = '';
                this.errorMsg = '';

            });

            this.modal.show();
        },

        closeModal() {
            // Reset field state first
            if (this.$refs.voucherCodeRef && typeof this.$refs.voucherCodeRef.resetField === "function") {
                this.$refs.voucherCodeRef.resetField();
            }
            this.voucher_code = '';
            this.errorMsg = '';
            // optionally close modal
            this.modal?.hide();
        },

        validateForm() {
            let inputRefer = ["voucherCodeRef"]
            let hasError = false;
            let firstInvalidField = null;
            inputRefer.forEach(ref => {
                const component = this.$refs[ref];
                const inputComponent = Array.isArray(component) ? component[0] : component;
                if (inputComponent && typeof inputComponent.validate === "function") {
                    inputComponent.validate();
                    if (inputComponent.hasError && !firstInvalidField) {
                        firstInvalidField = inputComponent; // Store first invalid field
                    }
                    if (inputComponent.hasError()) {
                        hasError = true;
                    }
                }
            });

            if (firstInvalidField) {
                this.$nextTick(() => {
                    firstInvalidField.$el.scrollIntoView({ behavior: "smooth", block: "center" });
                    firstInvalidField.$el.querySelector("input").focus();
                });
            }

            return hasError;
        },

        applyVoucher() {
            // emit value to parent
            if (!this.validateForm()) {
                this.$emit('applyVoucher', this.voucher_code);
            }
        },

        setError(errMsg){
            this.errorMsg = errMsg
        }
    }
}
</script>